<template>
  <div :class="['profile-header-container flex items-center justify-between p-0 mb-3', additionalClasses]">

    <div class="flex items-center justify-between mb-4 pt-[1px] w-full">

      <div class="logo-container">
        <img src="@/assets/images/logo/m4c-logo-small.svg" alt="Media4Change"
             class="w-[51px] h-[24px] -mt-[3px] md:mt-[4px] ml-0 mb-[1px] md:mb-0"/>
      </div>

      <div class="header-links">

        <div class="header-actions">

          <template v-if="auth.logged && auth?.user?.slug && showViewProfile">
            <router-link class="flex text-sm items-center mr-0" :to="localePath(`/profile/${auth.user.slug}`)">
              {{ t('auth.view_profile') }}
              <span class="ml-[8px] flex items-center">
                <img src="@/assets/images/elements/arrow-right.svg" :alt="t('auth.view_profile')" class="w-[16px]"/>
              </span>
            </router-link>
          </template>

          <template v-if="auth.logged && showBackToAuthProfile">
            <router-link class="flex text-sm items-center mr-0" :to="localePath(`/account/profile`)">
              {{ t('auth.back_to_auth_profile') }}
              <span class="ml-[8px] flex items-center">
                <img src="@/assets/images/elements/arrow-right.svg" :alt="t('auth.view_profile')" class="w-[16px]"/>
              </span>
            </router-link>
          </template>

          <template v-if="!auth.logged && showLoginLink">
            <router-link class="flex text-sm items-center mr-0" :to="localePath(`/auth/login`)">
              {{ t('auth.log_in') }}
              <span class="ml-[8px] flex items-center">
                <img src="@/assets/images/elements/arrow-right.svg" :alt="t('auth.log_in')" class="w-[16px]"/>
              </span>
            </router-link>
          </template>

        </div>

        <div class="menu-button">
          <button type="button" class="menu-button-item m-0  p-0" @click="onMenuButtonClick" aria-label="Menu">
            <img src="@/assets/images/elements/burger-menu.svg" alt="Media4Change" class="w-[24px] h-[24px] mt-[3px]"/>
          </button>
        </div>

      </div>

    </div>

  </div>
</template>

<script setup>
import EventBus from '@/components/app/AppEventBus';

const auth = useAuthStore();
const localePath = useLocalePath();

const { t } = useI18n();

const props = defineProps({
  additionalClasses: {
    type: String,
    default: '',
  },
  showViewProfile: {
    type: Boolean,
    default: false
  },
  showLoginLink: {
    type: Boolean,
    default: false
  },
  showBackToAuthProfile: {
    type: Boolean,
    default: false
  },
});

const onMenuButtonClick = (event) => {
  EventBus.emit('main-menu-clicked');
};

</script>

<style scoped>
.profile-header-container {
  border-bottom: 1px solid #D2D3D3; /* Light border */
}
.header-links a {
  font-weight: 400;
}
</style>
